import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Users from '../views/Users.vue';
import User from '../views/User.vue';
import Roles from '../views/Roles.vue';
import Role from '../views/Role.vue';
import Quotations from '../views/Quotations.vue'
import Quotation from '../views/Quotation.vue'
import Offers from '../views/Offers.vue'
import { store } from '../store';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {auth: true},
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    meta: { auth: false },
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    meta: { auth: true },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },{
    path: '/users',
    name: 'Users',
    meta: { auth: true },
    component: Users
  },{
    path: '/user/:userId',
    name: 'User',
    meta: { auth: true },
    component: User
  },{
    path: '/roles',
    name: 'Roles',
    meta: { auth: true },
    component: Roles
  },{
    path: '/role/:roleId',
    name: 'Role',
    meta: { auth: true },
    component: Role
    }, {
      path: '/quotations/',
      name: 'Quotations',
      meta: { auth: true },
      component: Quotations
    }, {
      path: '/quotation/:quotationId/:offerId',
      name: 'Quotation',
      meta: { auth: true },
      component: Quotation
    }, {
      path: '/offers/:offersId/:tk',
      name: 'Offers',
      meta: { auth: false },
      component: Offers
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('--------auth check---------');
  console.log(to);
  console.log(store.state.auth);
  console.log('--------auth check---------');
  if (to.meta.auth === true && store.state.auth.token == ''){

    //Serve auth ma non ho ancora il token
    const loginpath = window.location.pathname;
    next({ name: 'Login', query: { from: loginpath } });

  } else if (to.meta.auth === true && store.state.auth.token != ''){

    //Serve auth ed ho il token
    var now = Math.floor(Date.now() / 1000);
    if(store.state.auth.expire > now){
      var diff = store.state.auth.expire - now;
      console.log('session valid for next ' + diff + ' seconds');
      next();
    }else{
      //Qui dovrei far partire il refresh....ma per ora ti porto alla login
      console.log('session expired');
      store.commit('setAuth', { access_token: '', expire_in:''});
      const loginpath = window.location.pathname;
      next({ name: 'Login', query: { from: loginpath } });
    }
    
  }else{

    //Non serve auth
    next();

  }

})

export default router
